// extracted by mini-css-extract-plugin
export var profileTabSeparator = "profile-tab-separator_yW801d5Btb4_FD0lg_TJ";